var map = {
	"./login/index.js": 2526,
	"./login_farmer/index.js": 3854,
	"./login_mobile/index.js": 9076,
	"./orders/dashboard/index.js": 9938,
	"./orders/farmer/[order_id]/index.js": 1913,
	"./orders/farmer/index.js": 1429,
	"./orders/history/[order_id]/index.js": 7764,
	"./orders/history/index.js": 6593,
	"./orders/index.js": 4216,
	"./orders/payment/[order_id]/index.js": 9295,
	"./orders/payment/index.js": 789,
	"./orders/qrcode/[order_id]/index.js": 9647,
	"./orders/qrcode/index.js": 9609,
	"./orders/shipping/index.js": 3604,
	"./orders/shipping_product/[orders_id]/index.js": 588,
	"./profile/index.js": 9204,
	"./substance/pallet/[order_id]/index.js": 5895,
	"./substance/record/[batch_id]/index.js": 7225,
	"./vendor_management/detail/[id]/index.js": 6257,
	"./vendor_management/index.js": 3124,
	"./warehouse/add/index.js": 7492,
	"./warehouse/index.js": 1454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7365;